module.exports = __webpack_public_path__ + "static/media/menu-boczne-jak-to-dziala_BLUE.8ea8d057.svg";